import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class GISService {
	constructor(options) {
		this._options = options;
		this._rc = new RealtimeClient();
		this._restClient = new RestClient();
	}

	getGIS(callback) {
		const url = "/gis-app/api/gis-data";
		this._restClient.exec_get(url, callback);
	}
}
